// positioning per client request
// indices in array correspond to (int)OverlayType enum values
var hardcodedPositionsByOverlayTypeAndFips = [
    { // 0: USCongressionalDistricts
        3: [[40.784869324652725, -73.79702951072787], [40.75799451318282, -73.72946359695007]],
        5: [[40.68788495005717, -73.77732278674912], [40.60125529503077, -73.75533504589843]],
        7: [[40.70242291864709, -73.92081661328125], [40.65138942578652, -73.99566097363281], [40.7114798820512, -73.99154110058593]],
        8: [[40.659383664816204, -73.88525863898879], [40.57518318661758, -73.97437496289062]],
        10: [[40.62874848746662, -73.98825546516066], [40.77879590375711, -73.97437496289062]],
        11: [[40.58688151900327, -74.14340553104262], [40.618682558605144, -74.02427253543715]],
        12: [[40.7549499196378, -73.93813034309035], [40.724254585001546, -73.94843002570754], [40.755390878356025, -73.97338688364732], [40.788054633091924, -73.92142383750117]],
        13: [[40.873472018323184, -73.89593872738803], [40.82066308812443, -73.9408769251216]],
        14: [[40.78357929565804, -73.84001352370788], [40.763271636657265, -73.88113876594191], [40.85371741910896, -73.8478728301057], [40.78892008231452, -73.88266416542801]],
        16: [[40.890360156279506, -73.86053940070754]]
    },
    { // 1: StateSenateDistricts
        10: [[40.60033549805969, -73.75833865882402], [40.67745040787424, -73.79404422523027]],
        11: [[40.77351074800717, -73.79816409827714]],
        12: [[40.74365635189292, -73.92553683997636], [40.68979093888519, -73.89395114661698]],
        15: [[40.71248738234712, -73.88845798255448], [40.66693051457872, -73.8451993155623], [40.573897948440425, -73.85000583411698]],
        18: [[40.69744404461976, -73.92656680823808]],
        19: [[40.63321516596988, -73.89772769690995], [40.659525080606095, -73.88176318885331]],
        20: [[40.66151368481576, -73.93755313636308]],
        21: [[40.63827882920038, -73.93000003577714], [40.65312714749101, -73.97840854407792]],
        22: [[40.61837169184246, -74.01754733802323], [40.57692289190187, -73.94098636390214]],
        23: [[40.57775733467005, -73.97119876624589]],
        25: [[40.683334339021904, -73.95234491383574]],
        26: [[40.685270488989126, -73.99853862578492], [40.72121400641523, -73.95188285299741], [40.71668974120885, -73.99575130972397]],
        27: [[40.73446346710504, -74.00149299093685], [40.763333856438834, -73.98638678976498]],
        28: [[40.77092650675943, -73.95583106466732]],
        29: [[40.77763435906342, -73.96990729757748], [40.791411932393004, -73.9218421120306], [40.80492677364079, -73.91737891622982]],
        30: [[40.812982389093655, -73.94312812277279]],
        31: [[40.86181484818353, -73.92390204855404]],
        32: [[40.82883090587905, -73.88956977316342]],
        33: [[40.84909070526675, -73.89609290548763]],
        34: [[40.84961010587821, -73.84699775167904], [40.889072638783745, -73.9053626198431], [40.808045192405984, -73.87927009054623], [40.78829273213402, -73.88167334982357]],
    },
    { // 2: StateAssemblyDistricts
        23: [[40.59839616159631, -73.7465929954793], [40.66692020261446, -73.8454699486043], [40.57258372482687, -73.85233640368243]],
        26: [[40.76646397554606, -73.78474081563351]],
        27: [[40.72588771403487, -73.82319296407101], [40.7779040857792, -73.83829916524289]],
        30: [[40.724638821299244, -73.89597738789914]],
        31: [[40.65721589506579, -73.76551474141476], [40.59233186067387, -73.79572714375851], [40.60197725047939, -73.75727499532101]],
        34: [[40.755513803895454, -73.88670767354367]],
        38: [[40.689684112636705, -73.8554653029382]],
        41: [[40.60398213188293, -73.94816244649289]],
        44: [[40.63936978475293, -73.97735859511437]],
        46: [[40.61253067404839, -74.02439381239952], [40.57446840815796, -73.97838856337609]],
        49: [[40.618264205456605, -74.0013911878878]],
        50: [[40.72452078044448, -73.94862824340387]],
        51: [[40.65146141733449, -74.00046997924372]],
        53: [[40.70067290505296, -73.92390900512262]],
        58: [[40.647293697800364, -73.92562561889216]],
        59: [[40.61706994719295, -73.92150574584528]],
        61: [[40.633486267722105, -74.11548310180231]],
        62: [[40.525272771113656, -74.20577698607966]],
        64: [[40.57692417804279, -74.08939057250544]],
        65: [[40.712121683881016, -73.99137114506294]],
        68: [[40.79456582713964, -73.94090270023872], [40.79014712675658, -73.92133330326607]],
        71: [[40.83458065522495, -73.94364928226997]],
        73: [[40.754910973550366, -73.96875497361741]],
        76: [[40.772853387689814, -73.94884225389085]],
        77: [[40.843016267139056, -73.92000314256272]],
        79: [[40.83262644773503, -73.89597054978928]],
        81: [[40.88481882078327, -73.90524026414475]],
        82: [[40.829249405809605, -73.82730599900803]],
        84: [[40.807164508345934, -73.9186298515471]],
        85: [[40.82457321765843, -73.87880441209397], [40.78892008231452, -73.88266416542801]]
    },
    { // 3: CityCouncilDistricts
        1: [[40.717047485511024, -73.99864723458758]],
        8: [[40.79239378356402, -73.94042640155932], [40.788234878822934, -73.9229169411101], [40.80717904746301, -73.9218846987007]],
        9: [[40.811895594974885, -73.94435572818226]],
        13: [[40.83919914264212, -73.82999591834027]],
        16: [[40.83114671089866, -73.91308002478559]],
        17: [[40.819455956748854, -73.88904743201215]],
        20: [[40.74952825094271, -73.81694965369184]],
        22: [[40.76825217619735, -73.91136341101605], [40.78892008231452, -73.88266416542801]],
        28: [[40.67945034293794, -73.80236327068604]],
        31: [[40.59763257430382, -73.75811726975324], [40.66146972852111, -73.74335439133527]],
        32: [[40.66737497206612, -73.84147635826494], [40.55373624902019, -73.92112723717119]],
        33: [[40.72460371168821, -73.94932949182534], [40.70238351553799, -73.95982189284045], [40.694704947088745, -73.99183673964221]],
        35: [[40.67631612881499, -73.96501850704765]],
        37: [[40.67527461152218, -73.89395069698905]],
        39: [[40.66798353489923, -73.98218464474296]],
        41: [[40.669806378796565, -73.91626667599296]],
        42: [[40.66173340611894, -73.88433765987968]],
        46: [[40.617966106115155, -73.91798328976249]],
        49: [[40.62545910075206, -74.10290305380799]]
    },
    { // 4: ZipCodes
        // None for now
    },
    { // 5: PolicePrecincts
        1: [[40.71012689089476, -74.01060903470518]],
        25: [[40.79985094290456, -73.93748128812315], [40.78893448856273, -73.92306173245909]],
        32: [[40.81646269120736, -73.93956685485858]],
        45: [[40.83568726250907, -73.82730031433124]],
        47: [[40.885022121406365, -73.85373616638202]],
        61: [[40.59528589955862, -73.95177918988617]],
        63: [[40.617962386859844, -73.92808991986664]],
        69: [[40.63724437765526, -73.8997314582985]],
        75: [[40.66876104338793, -73.87981873857194]],
        100: [[40.58251069790033, -73.8224838386696]],
        105: [[40.697035153345404, -73.73557753050929]],
        110: [[40.73869789701868, -73.86991198505633]],
        113: [[40.679621386413594, -73.77343829120869]],
        114: [[40.76631612343358, -73.91550863187315], [40.78867455110601, -73.88323629300596]],
        115: [[40.75677031971883, -73.87632863646738]]
    },
    { // 6: SchoolDistricts
        4: [[40.79316914291773, -73.93950002318613], [40.79005002520676, -73.92267720824472]],
        5: [[40.81032167110717, -73.943619896233]],
        7: [[40.81006181738851, -73.91752736693613], [40.78892008231452, -73.88266416542801]],
        8: [[40.81915609203998, -73.87289540892831], [40.825339487508394, -73.82689015990488]],
        10: [[40.88615541900031, -73.90791432982675]],
        11: [[40.879614285271884, -73.85298268920175]],
        15: [[40.662306550485724, -73.9884269086338]],
        18: [[40.64198976159056, -73.91667245306739]],
        19: [[40.66907743870854, -73.87959359564552]],
        27: [[40.67239619796767, -73.83546670944858], [40.59840369588871, -73.75581583054233]],
        29: [[40.699537928625624, -73.75554433142224]]
    },
    { // 7: CommunityDistricts
        // Note: label text is in the overlay's .dbf file
        // "B10"
        35: [[40.82755027146717, -73.82774206991563]],
        // "B12"
        44: [[40.88464965915959, -73.8534912764586]],
        // "M01"
        36: [[40.71159212456818, -74.00922146163222]],
        // "M04"
        42: [[40.7552980004871, -74.00029507003066]],
        // "M05"
        26: [[40.7552980004871, -73.98250000000000]],
        // "Q13"
        46: [[40.70583642598386, -73.73761073683053]]
    },
];